<template>
  <div class="xy-container portrait">
    <Title />
    <div ref="testMain" class="test-main xy-scroll-col">
      <div class="test-content">
        <div class="write one">
          <div class="search_div">
            <span class="label">年级：</span>
            <a-select
              v-model="gradeId"
              class="select"
              :get-popup-container="triggerNode => triggerNode.parentNode"
              @change="checkGrade"
            >
              <a-select-option
                v-for="(item, i) in gradeList"
                :key="i"
                :value="item.id"
              >
                {{ item.studentGradeName }}
              </a-select-option>
            </a-select>
            <span class="label label2">班级：</span>
            <a-select
              v-model="classId"
              class="select"
              :get-popup-container="triggerNode => triggerNode.parentNode"
              @change="checkClass"
            >
              <a-select-option
                v-for="(item, i) in classList"
                :key="i"
                :value="item.stuorgId"
              >
                {{ item.studentOrgName }}
              </a-select-option>
            </a-select>
          </div>
          <div class="student_div">
            <div class="label">学&nbsp;&nbsp;&nbsp;&nbsp;生:</div>
            <div ref="studentList" class="student_list">
              <div
                v-for="(item, i) in studentList"
                :key="i"
                :class="['span', { active_name: item.studentId === studentId }]"
                @click="checkStudent(item)"
              >
                {{ item.studentName }}
              </div>
              <div v-if="studentList.length" class="exam_course_btn">
                <div class="exam_course_btn1" @click="zhanKai()">
                  <span v-if="showMore">收起</span>
                  <span v-if="!showMore">展开</span>
                  <a-icon :type="showMore ? 'up' : 'down'" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!studentInfo.studentId && sendState"
          class="not_div not_div2"
        >
          <div class="not_data">
            <NotData />
          </div>
        </div>
        <div v-else class="not_div2">
          <div class="write two">
            <div class="student_title">学生信息</div>
            <a-row>
              <a-col :span="2">
                <div class="avatar">
                  <img src="@static/img/header.png" alt="" />
                </div>
              </a-col>
              <a-col :span="20">
                <a-row>
                  <a-col :span="6" class="info_div">
                    <span class="label">学生姓名：</span>
                    <span class="text">
                      {{
                        studentInfo.studentName ? studentInfo.studentName : '--'
                      }}
                    </span>
                  </a-col>
                  <a-col :span="6" class="info_div">
                    <span class="label" style="width: 70px">
                      性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:
                    </span>
                    <span class="text">
                      {{
                        studentInfo.sex == -1
                          ? '--'
                          : studentInfo.sex == 1
                          ? '男'
                          : '女'
                      }}
                    </span>
                  </a-col>
                  <a-col :span="6" class="info_div">
                    <span class="label">
                      民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;族:
                    </span>
                    <span class="text">--</span>
                  </a-col>
                  <a-col :span="6" class="info_div">
                    <span class="label">
                      学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号:
                    </span>
                    <span class="text">
                      {{
                        studentInfo.studentCode ? studentInfo.studentCode : '--'
                      }}
                    </span>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="6" class="info_div">
                    <span class="label">身份证号:</span>
                    <span class="text">
                      {{ studentInfo.uIdn ? studentInfo.uIdn : '--' }}
                    </span>
                  </a-col>
                  <a-col :span="6" class="info_div">
                    <span class="label">
                      班&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;级:
                    </span>
                    <span class="text">
                      {{ studentInfo.name ? studentInfo.name : '--' }}
                    </span>
                  </a-col>
                  <a-col :span="6" class="info_div">
                    <span class="label">手&nbsp;&nbsp;机&nbsp;&nbsp;号:</span>
                    <span class="text">
                      {{ studentInfo.mobile ? studentInfo.mobile : '--' }}
                    </span>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </div>
          <!-- v-if="courseList.length === 0 && sendState2" -->
          <!-- v-if="tableData.length || courseList.length" -->
          <div v-if="tableData.length || courseList.length" class="grade-table">
            <div class="write three">
              <div class="student_title">成绩表</div>
              <div ref="table" class="table_div">
                <a-table
                  :columns="columns"
                  align="center"
                  :scroll="{
                    x: columns.length * 150 > tableWidth ? 1200 : 0
                  }"
                  :pagination="false"
                  :row-key="(record, index) => index"
                  :data-source="tableData"
                  bordered
                />
              </div>
            </div>
            <div class="write four">
              <div class="student_title">超均率跟踪</div>
              <div v-for="(item, i) in courseList1" :key="i" class="div_son">
                <div
                  :id="'courseRateCharts' + i"
                  class="courseRateCharts"
                ></div>
              </div>
            </div>
            <div class="write five">
              <div class="student_title">单科考试平稳度跟踪</div>
              <div v-for="(item, i) in courseList" :key="i" class="div_son">
                <div
                  :id="'courseSmoothCharts' + i"
                  class="courseSmoothCharts"
                ></div>
              </div>
            </div>
          </div>
          <div v-if="courseList.length === 0" class="not_div">
            <div v-if="sendState2" class="not_data">
              <NotData />
            </div>
          </div>
        </div>
      </div>
      <Backtop :data-ele="dataEle" />
    </div>
  </div>
</template>

<script>
  import axios, { DateFormat, getUser } from '@utils'
  import * as echarts from 'echarts'
  export default {
    name: 'Portrait',
    data() {
      return {
        dataEle: null,
        sendState: false,
        sendState2: false,
        tableWidth: 0,
        // index: 0,
        // index2: 0,
        schoolId: 0,
        gradeList: [],
        classList: [],
        showMore: false,
        gradeId: '',
        classId: '',
        studentId: '',
        studentList: [],
        studentInfo: {},
        columns: [],
        tableData: [],
        courseList: [],
        // courseId: 0,
        courseList1: []
        // courseId1: 0
      }
    },
    watch: {},
    async mounted() {
      this.dataEle = this.$refs.testMain
      await this.getUserInfo()
      // 获得 年级列表
      await this.gradeUrl()
    },
    methods: {
      // 获取用户信息
      getUserInfo() {
        return getUser().then(res => {
          if (res.status) {
            this.$store.commit('setuserInfo', res.data)
            this.schoolId = this.$store.state.userInfo.schoolId
          }
        })
      },
      zhanKai() {
        this.showMore = !this.showMore
        let dom = this.$refs.studentList
        if (!this.showMore) {
          dom.style.height = '48px'
          dom.style.overflow = 'hidden'
        } else {
          dom.style.height = 'auto'
          dom.style.overflow = 'none'
        }
      },
      checkGrade() {
        this.classUrl(this.gradeId)
      },
      checkClass() {
        this.studentUrl(this.classId)
      },
      checkStudent(item) {
        this.studentId = item.studentId
        this.studentInfoUrl(this.studentId)
      },
      // 获得 年级列表
      gradeUrl() {
        let grade = []
        let params = {
          schoolId: this.schoolId
        }
        return axios({
          url: 'getgradelist',
          params,
          loading: true
        })
          .then(res => {
            if (res.status && res.data) {
              grade.push(...res.data)
              this.gradeList = grade
              this.gradeId = grade[0].id
              this.classUrl(this.gradeId)
            } else {
              this.gradeList = grade
              this.gradeId = 0
              this.classList = []
              this.sendState = true
            }
          })
          .catch(() => {
            this.gradeList = grade
            this.gradeId = 0
            this.classList = []
          })
      },
      classUrl(gradeId) {
        let params = {
          schoolId: this.schoolId,
          gradeId
        }
        axios({
          url: 'getclasslist',
          params,
          loading: true
        }).then(res => {
          if (res.status && res.data) {
            this.classList = res.data
            this.classId = res.data[0].stuorgId
            this.studentUrl(this.classId)
          } else {
            this.classList = []
            this.classId = ''
            this.studentList = []
            this.studentInfo = {}
            this.courseList = []
            this.sendState = true
          }
        })
      },
      // 获取学生列表
      studentUrl(classId) {
        let params = {
          classId
        }
        axios({
          url: 'studentListUrl',
          params,
          loading: true
        }).then(res => {
          if (res.status && res.data) {
            this.studentList = res.data
            this.studentId = res.data[0].studentId
            this.studentInfoUrl(this.studentId)
          } else {
            this.studentList = []
            this.studentInfo = {}
            this.courseList = []
            this.sendState = true
          }
        })
      },
      // 获取学生信息
      studentInfoUrl(studentId) {
        let params = {
          studentId,
          schoolId: this.schoolId,
          classId: this.classId
        }
        axios({
          url: 'studentInfoUrl',
          params,
          loading: true
        }).then(res => {
          if (res.status) {
            this.studentInfo = res.data
            this.getScorereport(studentId)
            this.sendState = false
          } else {
            this.studentInfo = {}
            this.sendState = true
          }
        })
      },
      // 获取成绩表
      getScorereport(studentId) {
        let params = {
          studentId,
          schoolId: this.schoolId
        }
        axios({
          url: 'getscorereport',
          params,
          loading: true
        })
          .then(res => {
            if (res.status && res.data) {
              this.sendState2 = false
              let { data, courseList } = res.data
              if (courseList && courseList.length) {
                this.courseList = courseList
                this.courseList1 = [{ id: 0, name: '总分' }, ...courseList]
                this.getAllScoreReport()
                this.getAllRate()
                data.forEach(item => {
                  if (item.time) {
                    item.time = DateFormat(new Date(item.time), 'yyyy.MM.dd')
                  }
                })
                this.columns = [
                  {
                    title: '考试',
                    align: 'center',
                    dataIndex: 'title',
                    key: 'title',
                    ellipsis: true,
                    width: 150
                  },
                  {
                    title: '考试时间',
                    align: 'center',
                    dataIndex: 'time',
                    key: 'time',
                    ellipsis: true,
                    width: 150
                  },
                  {
                    title: '总分',
                    align: 'center',
                    dataIndex: 'total',
                    key: 'total',
                    ellipsis: true,
                    width: 150
                  }
                ]
                this.courseList.forEach((item, i) => {
                  this.columns.push({
                    title: item.name,
                    align: 'center',
                    dataIndex: 'name' + i,
                    key: 'name' + i,
                    ellipsis: true,
                    width: 150
                  })
                })
                data.forEach((ele, j) => {
                  this.courseList.forEach((item, i) => {
                    data[j]['name' + i] = data[j].scoreList[i]
                  })
                })
                this.tableData = data
                this.$nextTick(() => {
                  this.tableWidth = this.$refs.table.offsetWidth
                })
              } else {
                this.courseList = []
                this.tableData = []
                this.sendState2 = true
              }
            } else {
              this.courseList = []
              this.tableData = []
              this.sendState2 = true
            }
          })
          .catch(() => {
            this.courseList = []
            this.tableData = []
            this.sendState2 = true
          })
      },
      // 单科考试平稳度跟踪
      scoreReport(studentId, courseId, index, title) {
        let params = {
          schoolId: this.schoolId,
          courseId,
          studentId
        }
        axios({
          url: 'getstudentstable',
          params,
          loading: true
        }).then(res => {
          if (res.status && res.data) {
            this.studentStable(res.data.yTitle, index, title)
          }
        })
      },
      // 超均率跟踪
      upAvgScore(studentId, examType, courseId, index, title) {
        let params = {
          schoolId: this.schoolId,
          studentId,
          examType,
          courseId
        }
        axios({
          url: 'upAvgScoreListUrl',
          params,
          loading: true
        }).then(res => {
          if (res.status && res.data && res.data.xTitle) {
            let xTitle = []
            res.data.xTitle.forEach(item => {
              item = item.split('T')[0]
              xTitle.push(item)
            })
            setTimeout(() => {
              this.totalFen(
                xTitle,
                res.data.y1Title,
                res.data.y2Title,
                index,
                title
              )
            }, 200)
          }
        })
      },
      // 超均率学科所有图表
      getAllRate() {
        this.courseList1.forEach((item, i) => {
          this.upAvgScore(
            this.studentId,
            item.id == 0 ? 1 : 2,
            item.id,
            i,
            item.name
          )
        })
      },
      // 切换单科考试平稳度学科
      getAllScoreReport() {
        this.courseList.forEach((item, i) => {
          this.scoreReport(this.studentId, item.id, i, item.name)
        })
      },
      totalFen(xTitle, y1Title, y2Title, index, title) {
        let ec = echarts
        let lineChart = ec.init(
          document.getElementById('courseRateCharts' + index)
        )
        let x =
          document.getElementById('courseRateCharts' + index).offsetWidth - 43
        let option = {
          title: {
            text: title
          },
          toolbox: {
            feature: {
              saveAsImage: {
                show: true,
                title: '保存为图片',
                emphasis: {
                  iconStyle: {
                    borderColor: '@primary-color'
                  }
                }
              }
            },
            x,
            y: 10
          },
          tooltip: {
            trigger: 'axis',
            formatter(params) {
              var relVal = params[0].name
              for (var i = 0, l = params.length; i < l; i++) {
                relVal +=
                  '<br/>' + params[i].seriesName + ' : ' + params[i].value
              }
              return relVal
            }
            // axisPointer: {
            //   type: 'cross',
            //   label: {
            //     backgroundColor: '#6a7985'
            //   }
            // }
          },
          legend: {
            right: 40,
            itemWidth: 6,
            itemHeight: 6,
            data: [
              {
                name: '我的',
                // 强制设置图形为圆。
                icon: 'circle',
                textStyle: {
                  color: '#00AE76'
                }
              },
              {
                name: '均分',
                // 强制设置图形为圆。
                icon: 'circle',
                textStyle: {
                  color: '#1677FF'
                }
              }
            ]
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: xTitle,
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#E9E9E9'
                }
              },
              axisLabel: {
                textStyle: {
                  color: '#666666'
                },
                interval: xTitle.length > 10 ? 2 : 0,
                formatter: value => {
                  var str = ''
                  var cc = value.split('&')
                  var rowNum = cc.length
                  if (rowNum > 1) {
                    for (var i = 0; i < rowNum; i++) {
                      var temp = ''
                      if (i === 0 && cc[i].length > 4) {
                        temp = cc[i].substr(0, 4) + '...' + '\n' + '\n'
                      } else {
                        temp = cc[i] + '\n' + '\n'
                      }
                      str += temp
                    }
                    return str
                  } else {
                    return value
                  }
                }
              }
            }
          ],
          yAxis: {
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisTick: {
              show: false
            },
            type: 'value'
          },
          series: [
            {
              name: '我的',
              type: 'line',
              symbolSize: 6,
              smooth: true,
              color: '#13DE59',
              // color: '#42BBF6',
              lineStyle: {
                color: '#13DE59',
                width: 3
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.4, [
                  {
                    offset: 0,
                    color: '#13DE59'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              },
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
              data: y1Title
            },
            {
              name: '均分',
              type: 'line',
              smooth: true,
              symbolSize: 6,
              color: '#42BBF6',
              // color: '#13DE59',
              lineStyle: {
                color: '#42BBF6',
                width: 3
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.4, [
                  {
                    offset: 0,
                    color: '#42BBF6'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              },
              data: y2Title
            }
          ]
        }
        lineChart.setOption(option)
      },
      studentStable(yTitle, index, title) {
        let ec = echarts
        let lineChart = ec.init(
          document.getElementById('courseSmoothCharts' + index)
        )
        let option = {
          title: {
            text: title
          },
          xAxis: {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#E9E9E9'
              }
            }
          },
          yAxis: {
            min: 0,
            max: 5,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              formatter: value => {
                let texts = []
                if (value == 0) {
                  texts.push('C')
                } else if (value == 1) {
                  texts.push('C+')
                } else if (value == 2) {
                  texts.push('B')
                } else if (value == 3) {
                  texts.push('B+')
                } else if (value == 4) {
                  texts.push('A')
                } else if (value == 5) {
                  texts.push('A+')
                }
                return texts
              }
            }
          },
          series: [
            {
              data: yTitle,
              type: 'line',
              smooth: true,
              symbolSize: 6,
              // color: '#1677FF',
              color: '#13DE59',
              lineStyle: {
                color: '#13DE59',
                width: 3
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.4, [
                  {
                    offset: 0,
                    color: '#13DE59'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              },
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  formatter(params) {
                    var data = params.data
                    if (data == 0) {
                      return 'C'
                    } else if (data == 1) {
                      return 'C+'
                    } else if (data == 2) {
                      return 'B'
                    } else if (data == 3) {
                      return 'B+'
                    } else if (data == 4) {
                      return 'A'
                    } else if (data == 5) {
                      return 'A+'
                    }
                  }
                }
              }
            }
          ]
        }
        lineChart.setOption(option)
      } // 单科考试平稳度跟踪 画图
    }
  }
</script>
<style lang="less" scoped>
  .portrait {
    width: 100%;
    height: 100%;
    background: #f7f8fb;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    padding-right: 0;
    .write {
      background: #fff;
      margin-bottom: 12px;
      padding: 20px;
      .student_title {
        font-size: 16px;
        font-weight: 550;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 18px;
      }
    }
    .not_div {
      min-height: 400px;
      background-color: #fff;
      padding-top: 1px;
      flex: auto;
      position: relative;
      .not_data {
        width: 300px;
        height: 300px;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        p {
          margin-top: 10px;
          text-align: center;
        }
        img {
          width: 100%;
        }
      }
    }
    .not_div2 {
      display: flex;
      flex-direction: column;
      flex: auto;
      min-height: 400px;
    }
    .top_title {
      height: 48px;
      line-height: 48px;
      padding-left: 32px;
      font-size: 16px;
      font-weight: 550;
      color: #333;
      background: #fff;
      border-bottom: 1px solid #f7f8fb;
    }
    .test-main {
      width: 100%;
      display: flex;
      flex-direction: column;
      flex: auto;
      height: calc(100% - 68px);
      padding-right: 18px;
      scrollbar-gutter: stable;
      .test-content {
        display: flex;
        flex-direction: column;
        flex: auto;

        .grade-table {
          flex: auto;
        }
        .one {
          padding: 0 @padding-lg;
          .label {
            color: rgba(0, 0, 0, 0.85);
          }
          .search_div {
            min-height: 48px;
            line-height: 48px;
            border-bottom: 1px dashed #e5e5e5;
            position: relative;
            .select {
              width: 180px;
            }
            .label2 {
              margin-left: 20px;
            }
          }
          .student_div {
            min-height: 48px;
            line-height: 48px;
            .label {
              float: left;
              margin-right: 18px;
            }
            .student_list {
              position: relative;
              font-size: 14px;
              padding-right: 105px;
              width: calc(100% - 68px);
              display: flex;
              flex-wrap: wrap;
              height: 48px;
              overflow: hidden;
              .span {
                float: left;
                margin-right: 20px;
                margin-top: 14px;
                margin-bottom: 14px;
                max-width: 84px;
                line-height: 20px;
                height: 20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: pointer;
              }
              .active_name {
                background: @primary-color;
                line-height: 20px;
                height: 20px;
                border-radius: 4px;
                color: #fff;
                padding: 0 10px;
              }
              .exam_course_btn {
                position: absolute;
                color: @primary-color;
                cursor: pointer;
                height: 100%;
                right: 0px;
                line-height: 48px;
                span {
                  margin-right: 4px;
                }
              }
            }
          }
        }
        .two {
          .avatar {
            width: 60px;
            height: 60px;
            margin-right: 20px;
            background: #e6f3ff;
            border: 1px solid #9aceff;
            border-radius: 5px;
            text-align: center;
            padding-top: 4px;
          }
          .info_div {
            height: 30px;
            line-height: 30px;
            .label {
              display: block;
              min-width: 70px;
              font-size: @font-size-base;
              color: rgba(0, 0, 0, 0.85);
              float: left;
            }
            .text {
              max-width: 180px;
              font-size: @font-size-base;
              color: rgba(0, 0, 0, 0.65);
              display: block;
              float: left;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
        .four {
          .courseRateCharts {
            width: 100%;
            height: 100%;
          }
          .div_son {
            width: 100%;
            height: 440px;
            padding: 20px;
          }
        }

        .five {
          .courseSmoothCharts {
            width: 100%;
            height: 100%;
          }
          .div_son {
            width: 100%;
            height: 440px;
            padding: 20px;
          }
        }
      }
    }
  }
</style>
